import { Component } from "react";

const title = "Our Vision";
const desc =
    "Our vision is a global esports ecosystem where talent rises, competition thrives, and gamers turn passion into professional careers.";



class Vision extends Component {
    render() {
        const { imgUrl } = this.props;

        return (
            <section
                className="vision-section"
                style={{backgroundImage: "url('/assets/images/about/about-3.jpg')"}}
            >
                <div className="container">
                    <div className="section-wrapper padding-top">
                        <div className="row">

                            {/* IMAGE LEFT */}
                            <div className="col-lg-6">
                                <div className="vision-image">
                                    <img src={imgUrl} alt="" />
                                </div>
                            </div>

                            {/* CONTENT RIGHT */}
                            <div className="col-lg-6 col-md-10">
                                <div className="vision-wrapper">
                                    <div className="section-header">


                                        <h2 className="text-anim-typing js-animate delay-md">
                                            {title}
                                        </h2>
                                    </div>

                                    <div className="vision-content text-anim-fade-down js-animate delay-md">
                                        <p>{desc}</p>

                                        <ul className="vision-list">

                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        );
    }
}


export default Vision;